import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getRegisterOfInformationSteps } from 'constants/registerOfInformationSteps';
import { stepPathMap } from 'constants/stepPaths';
import { useTranslation } from 'react-i18next';
import StepComponent from 'components/StepComponent/CustomSteps';

const RegisterOfInformationSteps: React.FC = () => {
  const location = useLocation();
  const [current, setCurrent] = useState(0);
  const { t } = useTranslation();
  const registerOfInformationSteps = getRegisterOfInformationSteps(t);

  useEffect(() => {
    const stepIndex = stepPathMap[location.pathname];

    if (stepIndex !== undefined) {
      setCurrent(stepIndex);
    }
  }, [location.pathname]);

  const title = registerOfInformationSteps[current]?.title;

  return (
    <StepComponent
      steps={registerOfInformationSteps}
      current={current}
      onStepChange={setCurrent}
      title={title}
    />
  );
};

export default RegisterOfInformationSteps;
